import { render } from "./CountryDisclaimer.vue?vue&type=template&id=6de90e73&ts=true"
import script from "./CountryDisclaimer.vue?vue&type=script&lang=ts"
export * from "./CountryDisclaimer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__